module.exports = __webpack_public_path__ + "static/media/shawarma_imperatriz.d417ea41.jpg";